export default {
  noData: "該当のデータがありません。",
  titleConfirmUndoPopup: "評価確定取り消し確認",
  messageConfirmUndoPopup: "評価確定を取り消しますか？",
  titleConfirmPopup: "評価確定確認",
  messageConfirmPopup: "評価を確定してもよろしいですか？",
  titleConfirmRejectPopup: "評価確定差し戻し",
  messageConfirmRejectPopup: "評価確定を差し戻してもよろしいですか？",
  titleConfirmTransferMemberPopup: "転送メンバー",
  messageConfirmTransferMemberPopup: "メンバー移行しますか？",
  noDepartment: "部署なし",
  titleRemoveMemberMember: "メンバー削除確認",
  messageRemoveMemberMember: "メンバーを削除しますか？",
};
